// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AvgreachController from "./avgreach_controller"
application.register("avgreach", AvgreachController)

import BubbleController from "./bubble_controller"
application.register("bubble", BubbleController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import HistogramController from "./histogram_controller"
application.register("histogram", HistogramController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)

import ProfileChartController from "./profile_chart_controller"
application.register("profile-chart", ProfileChartController)

import RevealBarController from "./reveal_bar_controller"
application.register("reveal-bar", RevealBarController)

import TimeseriesChartController from "./timeseries_chart_controller"
application.register("timeseries-chart", TimeseriesChartController)
